module.exports = __webpack_public_path__ + "img/telegram-elipse.f0c33f00.svg";